// Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

// RxJS
import { filter, map, take } from 'rxjs/operators';

// Local
import { AuthService } from '@core/auth/auth.service';

export const isInternalUser: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {

  const authService = inject(AuthService);

  // Wait until the user permissions are loaded
  return authService.sessionUser.pipe(
    filter((user) => !!user),
    take(1),
    map(() => {
      // Check if the user is internal based on their permissions
      return authService.userPermissions.isInternalUser;
    })
  )
};
